import React, {useState, useRef, useCallback} from 'react';
import JoditEditor from 'jodit-react';
import {Jodit} from 'jodit';
import 'jodit/build/jodit.min.css';

const CXTextEditorJodit = ({htmlContent, onBlurEvent, tabIndex, secIndex, secItemIndex}) => {
    const editor = useRef(null);
    const [content, setContent] = useState(htmlContent || '');
    Jodit.modules.Icon.set('dividerIcon', '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.44173 4.21134L3.46815 5.81872L8.22614 7.45453L13.1997 5.84714L8.44173 4.21134ZM8.58128 3.37811C8.49599 3.34878 8.40349 3.34793 8.31767 3.37566L2.02291 5.41003C1.64194 5.53315 1.63695 6.07036 2.01558 6.20053L8.0866 8.28776C8.17188 8.31708 8.26438 8.31794 8.3502 8.2902L14.645 6.25584C15.0259 6.13271 15.0309 5.5955 14.6523 5.46533L8.58128 3.37811ZM4.3536 7.87228C4.55943 7.76937 4.64285 7.51909 4.53994 7.31327C4.43703 7.10744 4.18675 7.02402 3.98092 7.12693L3.11779 7.55849C2.48322 7.87578 2.5101 8.79033 3.1622 9.0698L7.53526 10.944C8.04312 11.1616 8.61664 11.1686 9.12966 10.9634L14.0032 9.01398C14.6262 8.76478 14.7143 7.91907 14.156 7.54688L13.5651 7.15292C13.3736 7.02527 13.1149 7.07701 12.9872 7.26848C12.8596 7.45995 12.9113 7.71865 13.1028 7.84629L13.6937 8.24025L8.82016 10.1897C8.51235 10.3128 8.16824 10.3086 7.86352 10.178L3.49047 8.30385L4.3536 7.87228ZM4.3536 11.2056C4.55942 11.1027 4.64285 10.8524 4.53994 10.6466C4.43702 10.4408 4.18674 10.3573 3.98092 10.4603L3.16888 10.8663C2.51806 11.1917 2.56765 12.1364 3.24896 12.3919L8.34045 14.3012C8.88287 14.5046 9.4855 14.473 10.0037 14.2139L10.1869 14.1223C10.3928 14.0194 10.4762 13.7691 10.3733 13.5633C10.2704 13.3574 10.0201 13.274 9.81425 13.3769L9.63097 13.4686C9.32008 13.624 8.95851 13.643 8.63305 13.5209L3.54156 11.6116L4.3536 11.2056ZM14.5839 16.4996C16.1027 16.4996 17.3339 15.2684 17.3339 13.7496C17.3339 12.2308 16.1027 10.9996 14.5839 10.9996C13.0651 10.9996 11.8339 12.2308 11.8339 13.7496C11.8339 15.2684 13.0651 16.4996 14.5839 16.4996ZM14.5839 17.4996C16.655 17.4996 18.3339 15.8207 18.3339 13.7496C18.3339 11.6785 16.655 9.9996 14.5839 9.9996C12.5129 9.9996 10.8339 11.6785 10.8339 13.7496C10.8339 15.8207 12.5129 17.4996 14.5839 17.4996ZM15.0006 12.0829C15.0006 11.8528 14.814 11.6663 14.5839 11.6663C14.3538 11.6663 14.1673 11.8528 14.1673 12.0829V13.3329H12.9173C12.6871 13.3329 12.5006 13.5195 12.5006 13.7496C12.5006 13.9797 12.6871 14.1663 12.9173 14.1663H14.1673V15.4163C14.1673 15.6464 14.3538 15.8329 14.5839 15.8329C14.814 15.8329 15.0006 15.6464 15.0006 15.4163V14.1663H16.2506C16.4807 14.1663 16.6673 13.9797 16.6673 13.7496C16.6673 13.5195 16.4807 13.3329 16.2506 13.3329H15.0006V12.0829Z" fill="#7A7A7A"/></svg>');

    const config = {
        readonly: false, // all options from https://xdsoft.net/jodit/doc/
        height: '450px',
        width: '100%',
        enableDragAndDropFileToEditor: true,
        toolbarButtonSize: "large",
        useSearch: true,
        defaultFontSizePoints: "20px",
        buttons: [
            'bold',
            '|',
            'underline',
            '|',
            'ul',
            '|',
            'indent',
            '|',
            'outdent',
            '|',
            'hr',
        ],
        controls: {
            bold: {
                name: 'bold',
                tooltip: 'Bold',
                css: 'textEditor-button'
            },
            ul: {
                list: false,
                text: 'unordered list'
            },
            hr: {
                name: 'Add divider',
                icon: 'dividerIcon',
                text: 'Add divider'
            }
        },
        removeButtons: ['brush', 'file', 'italic', 'font-style', 'color', 'media', 'history', 'paragraph', 'ol', 'source'],
        extraButtons: [],
        showXPathInStatusbar: false,
        showCharsCounter: false,
        showWordsCounter: false,
        toolbarAdaptive: false,
        toolbarSticky: false,
        defaultActionOnPaste: "insert_clear_html",
        editorStyle: {},
        style: {
            fontSize: '20px', // Adjust the font size
            background: '#FFFFFF',
            strong: {
                fontWeight: 'bold', // Use 'bold' for font weight
            }
        }
    };

    const renderEditor = useCallback(() => (
      <JoditEditor
        className='port-text-edit'
        ref={editor}
        value={content}
        config={config as any}
        onBlur={(e) => onBlurEvent(e, secIndex, secItemIndex)} // preferred to use only this option to update the content for performance reasons
        onChange={() => {
        }}
      />
    ), [htmlContent, tabIndex, secIndex, secItemIndex]);

    return renderEditor();
};

export default CXTextEditorJodit;
